import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component", "pageContext"];
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import LoadingBar from '../../components/LoadingBar';
import app from '../../configuration/app';
import withMemo from '../../decorators/withMemo';
import ErrorView from '../../pagesContents/Error';
import { actions as AppActions, selectors as AppSelectors } from '../../redux/app/redux';
import { actions as TrackingActions } from '../../redux/tracking/redux';
import { Router } from '../../routes';
import Metadatas from '../../components/Metadatas';
import { usePageTracking } from '../../hooks/usePageTracking';
import styles from './styles';
var useStyles = createUseStyles(styles);
var AppGate = function AppGate(props) {
  // eslint-disable-next-line react/prop-types
  var Component = props.Component,
    pageContext = props.pageContext,
    pageProps = _objectWithoutProperties(props, _excluded);
  var preview = useSelector(AppSelectors.preview);
  var seo = useSelector(AppSelectors.seo);
  var jsonld = useSelector(AppSelectors.jsonld);
  var alternates = useSelector(AppSelectors.alternates);
  var isError = pageProps.error;
  var isErrorComp = pageProps.errorComponent;
  var classes = useStyles(props);
  var dispatch = useDispatch();
  usePageTracking();
  useEffect(function () {
    Router.onRouteChangeComplete = function (url) {
      dispatch(TrackingActions.trackPage(url));
      dispatch(AppActions.scrollTop(url));
    };
    dispatch(AppActions.initBrowser());
  }, [dispatch]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Metadatas, {
    applicationName: "Balenciaga CV",
    seo: seo,
    alternates: alternates,
    base: preview === true ? app.APP_PREVIEW_URL : app.APP_URL,
    jsonld: jsonld || {}
  }), /*#__PURE__*/React.createElement(LoadingBar, null), isError && !isErrorComp && /*#__PURE__*/React.createElement(ErrorView, _extends({
    pageContext: pageContext
  }, pageProps)), Component && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({
    pageContext: pageContext
  }, pageProps))));
};
AppGate.propTypes = {
  pageProps: PropTypes.shape({
    error: PropTypes.number,
    errorComponent: PropTypes.any
  })
};
AppGate.defaultProps = {
  pageProps: {}
};
export default withMemo()(AppGate);